'use client';

import { type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from '@/components/link';
import { cn } from '@/lib/utils';
import { USER_ACTION_ITEM_CLASSES } from './item-classes';

/**
 * NDULGE loyalty link. `/NDULGE` resolves to `/uk/NDULGE` via the `Link` wrapper's locale prefix.
 * Visibility is the consumer's call via `className` (the header hides it on mobile).
 */
export const NdulgeLink = ({ className }: { className?: string }): ReactElement => {
    const { t } = useTranslation('header');

    return (
        <Link to="/NDULGE" className={cn(USER_ACTION_ITEM_CLASSES, className)}>
            {t('userActions.ndulge')}
        </Link>
    );
};
